//@flow
import api from '../Utils/apiBuilder';
import Constants from '../constants';

export default {
  getStockReminders() {
    return api('stockreminders')
      .get()
      .dispatch(Constants.GET_STOCK_REMINDERS_SUCCESS);
  },

  setStockReminder(email:string, sku:string) {
    return api('stockreminders').noauth()
      .post({ email, sku })
      .dispatch(Constants.SET_STOCK_REMINDER_SUCCESS);
  },
};
